export class FormationDto {
  constructor(public id: number, public trainingTitle: string, public beginDateFormation: Date, public endDateFormation: Date) {}

  public static fromJson(json: any): FormationDto {
    return new FormationDto(
      json.id,
      json.trainingTitle,
      json.beginDateFormation ? new Date(json.beginDateFormation) : undefined,
      json.endDateFormation ? new Date(json.endDateFormation) : undefined,
    );
  }
}
